module.exports = __webpack_public_path__ + "static/img/px5.732858c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/px5.png
// module id = fWQv
// module chunks = 2